<template>
  <div class="navigation-bar">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item class="breadcrumb-item">财务服务</el-breadcrumb-item>
      <el-breadcrumb-item class="breadcrumb-item">贷款申请</el-breadcrumb-item>
      <el-breadcrumb-item class="breadcrumb-item active">贷款申请详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 返回列表按钮 - 使用Element UI组件 -->
    <el-button type="primary" class="back-to-list-btn" @click="handleBack">
      <i class="el-icon-arrow-left"></i>
      <span>返回列表</span>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'HeaderCard',
  methods: {
    // 返回列表
    handleBack() {
      // 返回上一页或列表页
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
// 变量定义 - 从设计稿提取
@primary-color: #2563eb; // 主色调
@primary-blue: #1677ff; // 按钮主色
@text-secondary: #6b7280; // 次要文本色
@text-active: #2563eb; // 激活状态文本色
@gray-light: #d1d5db; // 浅灰色
@white: #ffffff; // 白色背景
@border-radius: 6px; // 圆角
@button-shadow: 0px 2px 0px 0px rgba(5, 145, 255, 0.1); // 按钮阴影

// 导航栏样式
.navigation-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 64px;
  padding: 16px 0;
  margin-bottom: 0;
  box-sizing: border-box;
}

// 面包屑样式 - Element UI 定制
.breadcrumb {
  // 覆盖Element UI默认样式
  :deep(.el-breadcrumb__inner) {
    font-size: 14px;
    line-height: 20px;
    color: @text-secondary;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;

    // 激活状态样式
    &.active {
      color: @text-active;
      font-weight: 500;
    }
  }

  // 分隔符样式
  :deep(.el-breadcrumb__separator) {
    font-size: 14px;
    line-height: 20px;
    color: @gray-light;
    font-family: 'Roboto', sans-serif;
    margin: 0 8px;
  }
}

// 返回列表按钮样式 - Element UI 定制
.back-to-list-btn {
  // 覆盖Element UI默认按钮样式
  &.el-button {
    width: 110px;
    height: 32px;
    background-color: @primary-blue;
    border-color: @primary-blue;
    border-radius: @border-radius;
    box-shadow: @button-shadow;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 0 15px;
    font-size: 14px;
    line-height: 22px;
    color: @white;
    font-family: 'Segoe UI', sans-serif;

    &:hover {
      background-color: darken(@primary-blue, 5%);
      border-color: darken(@primary-blue, 5%);
      color: @white;
    }

    &:active {
      background-color: darken(@primary-blue, 10%);
      border-color: darken(@primary-blue, 10%);
      color: @white;
    }
  }
}
</style>